/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DashboardMensaDTO } from './dashboard-mensa-dto';
import { DashboardDenaroDTO } from './dashboard-denaro-dto';
import { DashboardEsercentiDTO } from './dashboard-esercenti-dto';
import { DashboardPraticheDTO } from './dashboard-pratiche-dto';


export interface DashboardDTO { 
    pratiche?: DashboardPraticheDTO;
    denaro?: DashboardDenaroDTO;
    mensa?: DashboardMensaDTO;
    esercenti?: DashboardEsercentiDTO;
}

